import React from "react"
import {FieldManagementPreviewProps} from "../../../../../render/management-preview";


export default function FieldDatetime_ManagementPreview(props: FieldManagementPreviewProps) {

    let value     = {
        date: moment(),
        time: moment()
    }

    const displayValue = props.field.getDisplayValue(value)

    return (
        <div className="txt-truncate cursor-default">
            {displayValue}
        </div>
    )
}
